import React, { useEffect, useRef } from 'react';
import { useField } from '@unform/core';
import PropTypes from 'prop-types';
import { FieldWrap, Label, TextareaField, ErrorText } from './styles';

/**
 * Textarea nativo integrado ao Unform — mesmo padrão visual que
 * borracharia_major /stock-movement/new (evita MUI TextField multiline + FormWrapper).
 */
function FormTextarea({ name, label, placeholder, defaultValue: defaultValueProp, ...rest }) {
  const textareaRef = useRef(null);
  const { fieldName, defaultValue, registerField, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: textareaRef,
      getValue: (ref) => (ref.current ? ref.current.value : ''),
      setValue: (ref, value) => {
        if (ref.current) ref.current.value = value;
      },
      clearValue: (ref) => {
        if (ref.current) ref.current.value = '';
      },
    });
  }, [fieldName, registerField]);

  return (
    <FieldWrap>
      {label ? <Label htmlFor={fieldName}>{label}</Label> : null}
      <TextareaField
        ref={textareaRef}
        id={fieldName}
        name={fieldName}
        defaultValue={defaultValueProp !== undefined ? defaultValueProp : defaultValue}
        placeholder={placeholder}
        {...rest}
      />
      {error ? <ErrorText>{error}</ErrorText> : null}
    </FieldWrap>
  );
}

FormTextarea.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
};

export default FormTextarea;
